import React from 'react';
import { Star } from 'lucide-react';
export const TestimonialsFull = () => {
  const testimonials = [{
    initials: 'MP',
    name: 'Marcela P.',
    location: 'Buenos Aires 🇦🇷',
    role: 'Profesora de Patín en Club Propio',
    quote: 'Compré un sábado. El domingo a la noche tenía el mes de clases listo. Nunca más improviso.'
  }, {
    initials: 'CG',
    name: 'Carolina G.',
    location: 'Córdoba 🇦🇷',
    role: 'Profesora en Academia Privada',
    quote: 'Tres alumnos iniciales que estaban estancados progresaron de forma visible en el primer mes con el Tomo 1 y 2. Los padres me lo agradecen.'
  }, {
    initials: 'FR',
    name: 'Fernando R.',
    location: 'Rosario 🇦🇷',
    role: 'Profesor Independiente',
    quote: 'Antes tardaba 2 horas armando la clase del miércoles. Ahora son 5 minutos. No puedo creer que no existiera antes.'
  }, {
    initials: 'SV',
    name: 'Sofía V.',
    location: 'Mendoza 🇦🇷',
    role: 'Profesora en Escuela Municipal',
    quote: 'El Bonus de Puntuación de Oro cambió cómo preparo a mis alumnos para competencia. Ahora sé exactamente qué miran los jueces y qué necesito trabajar.'
  }, {
    initials: 'DA',
    name: 'Diego A.',
    location: 'Santa Fe 🇦🇷',
    role: 'Profesor de Patín y Entrenador',
    quote: 'El Acelerador Axel me salvó con una alumna adulta que llevaba 8 meses sin poder lograrlo. En 6 semanas con el protocolo del ebook lo hizo. Ella lloró. Yo también.'
  }, {
    initials: 'CR',
    name: 'Claudia R.',
    location: 'Tucumán 🇦🇷',
    role: 'Profesora de Patín en Club de Barrio',
    quote: 'La Planificación Anual 360 cambió mi relación con la enseñanza. Llego al club con energía, no agotada de inventar ejercicios en el colectivo.'
  }];
  return <section className="py-20 bg-gray-50" data-id="element-266">
      <div className="max-w-6xl mx-auto px-4" data-id="element-267">
        <div className="text-center mb-16" data-id="element-268">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-269">
            Lo que dicen los profesores
          </h2>
          <div className="flex items-center justify-center gap-2 text-xl font-bold text-gray-700" data-id="element-270">
            4.9/5{' '}
            <div className="flex" data-id="element-271">
              <Star className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-272" />
              <Star className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-273" />
              <Star className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-274" />
              <Star className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-275" />
              <Star className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-276" />
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-277">
          {testimonials.map((t, i) => <div key={i} className="bg-white p-8 rounded-2xl shadow-md border border-gray-100 flex flex-col" data-id="element-278">
              <div className="flex items-center gap-4 mb-4" data-id="element-279">
                <div className="w-12 h-12 rounded-full bg-brand-700 text-white font-bold flex items-center justify-center text-lg shrink-0" data-id="element-280">
                  {t.initials}
                </div>
                <div data-id="element-281">
                  <div className="font-bold text-gray-900" data-id="element-282">
                    {t.name} — {t.location}
                  </div>
                  <div className="text-sm text-brand-600 font-medium" data-id="element-283">
                    {t.role}
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-0.5 mb-4" data-id="element-284">
                {[...Array(5)].map((_, idx) => <Star key={idx} className="w-4 h-4 fill-amber-400 text-amber-400" data-id="element-285" />)}
              </div>
              <p className="text-gray-700 italic flex-1" data-id="element-286">"{t.quote}"</p>
            </div>)}
        </div>
      </div>
    </section>;
};